import type { FC } from "react";

import { Cog } from "lucide-react";
import { Link } from "react-router-dom";

import { AccountController } from "../../api/accountController";
import { useUserContext } from "../../contexts/userContext";
import styles from "./header.module.scss";
import { NavDropdown } from "./navDropdown";

export const Header: FC = () => {
	const { user } = useUserContext();

	const onLogout = async () => {
		await AccountController.logout();
		window.location.replace("/MVC/Account");
	};

	const repItems = [
		{ to: "/reps", label: "Representatives" },
		{ to: "/customer-incidents", label: "Customer Incidents" },
		{ to: "/drug-tests", label: "Drug Tests" },
		{ to: "/background-checks", label: "Background Checks" },
		{ to: "/field-audits", label: "Field Audits" },
	];

	const mapItems = [
		{ to: "/maps", label: "Default Maps" },
		{ to: "/layerMaps", label: "Layer Maps" },
		{ to: "/layerMapsV2", label: "Layer Maps V2" },
	];

	const adminItems = [
		{ to: "/enrollment-validation", label: "Enrollment Validations" },
		{ to: "/pre-enrollment-validation", label: "Pre Enrollment Validations" },
	];

	return (
		<div className={styles.header}>
			<div className={styles.menuWrapper}>
				<div className={styles.menuItem}>
					<Link to="/">
						<img className={styles.tlpLogo} src="/Content/Logos/TLPLogo2.png" alt="TLP Logo" />
					</Link>
				</div>
				<nav className={styles.nav}>
					<NavDropdown label="Maps" to="/maps" items={mapItems} />
					<NavDropdown label="Reps" to="/reps" items={repItems} />
					<Link to="/locations" className={styles.navLink}>
						Locations
					</Link>
					<Link to="/leads" className={styles.navLink}>
						Leads
					</Link>
					<Link to="/my-view" className={styles.navLink}>
						My View
					</Link>
					<NavDropdown label="Admin" to="/enrollment-validation" items={adminItems} />
				</nav>
			</div>

			<div className={styles.rightMenuDiv}>
				<div className={styles.loginDisplay}>
					<div className={styles.userBox}>
						<span className={styles.userName}>{user?.userName}</span>
						<button onClick={onLogout} className={styles.logoutButton}>
							Log Out
						</button>
					</div>
				</div>
				<div className={styles.gearWrapper}>
					<Link to="/Account">
						<Cog />
					</Link>
				</div>
				<div className={styles.companyLogoWrapper}>
					<img className={styles.companyLogo} src="/Content/Logos/TLPLogo2.png" alt="Company Logo" />
				</div>
			</div>
		</div>
	);
};
